import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { AddCompetenceBrandViewModel, BrandValueViewModel } from '../../../business-entities/addCompetence-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { CompetenceBusinessService } from '../../../business-services/competence.service';

@Component({
  selector: 'app-edit-competence',
  templateUrl: './edit-competence.component.html'
})
export class EditCompetenceComponent implements OnInit {


  CompetenceViewModel:any;
  brandList: BrandValueViewModel[];
  isSelectAllBrand:boolean;
  isView:boolean;


  constructor(
    private competenceService: CompetenceBusinessService,
    private brandService: BrandService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  async getData()
  {
    const routeCompetenceId = this.competenceService.competenceId;
    await this.getComptenceById(routeCompetenceId);
    await this.getBrandList();
     this.mapBrandValue();
     this.selectBrand();
  }

  selectAllBrand()
  {
    if(this.isSelectAllBrand)
    {
      for (let item of this.brandList) {
        item.value=true;
      }
    }
    else{
      for (let item of this.brandList) {
        item.value=false;
      }
    }
  }

  selectBrand() {
    this.isSelectAllBrand = this.brandList.every(x => x.value);
  }

  private async getComptenceById(Id: number){
    this.spinner.show();
     await this.competenceService.getCompetenceById(Id).then( result => {
      this.CompetenceViewModel = result.responseObject;
      this.isView = this.CompetenceViewModel.isDefault;
      this.spinner.hide();

    },
    _error => {
        this.spinner.hide()
      });
  }

  async getBrandList() {
    this.spinner.show();
     await this.brandService.getBrand().then(response => {
      if (response) {
        this.brandList = response;
        this.spinner.hide();
      } else if (
        response.responseObject &&
        response.responseObject.errorCount > 0
      ) {
        if (
          response.responseObject.result &&
          response.responseObject.result.errorCode ===
          Enums.ErrorCodes.ServiceCategoriesCode
        ) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  mapBrandValue()
  {
    for (let brand of this.brandList){
         this.CompetenceViewModel.comptenceBrand.find(obj => {
            if( obj.brandId === brand.id)
            {
              brand.value=true;
            }
        })
     }
  }


  EditCompetence() {
    let successMessage = this.translate.instant("lblCompetenceEditedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue");
    this.CompetenceViewModel.comptenceBrand=[];
    for (let item of this.brandList) {
      if (item.value) {
        let CompetenceBrand: AddCompetenceBrandViewModel = {
          BrandId: 0,
          Value: null
        };
        CompetenceBrand.BrandId = item.id;
        CompetenceBrand.Value = item.value.toString();
        this.CompetenceViewModel.comptenceBrand.push(CompetenceBrand);
      }
    }
    this.CompetenceViewModel.priority=Number(this.CompetenceViewModel.priority);
    this.competenceService.updateCompetence(this.CompetenceViewModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.activeModal.close({ success: true });
        this.toaster.success(successMessage);
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAddedComptence");
        this.toaster.warning(errormsg);
      }
    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  public onChangeIsActive(value: boolean) {
    this.CompetenceViewModel.IsActive = !value;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
}
